const isWeiXin = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
};

const config = {
  // 不校验登录态的路由
  loginWhiteList: [
    '/register',
    '/pay',
    '/payResult',
    '/agreement',
    '/share',
    '/share-down',
    '/credit-recycle-info',
    '/report',
    '/device-detail'
  ],
  // 需要校验豹哥权限的路由（目前校验功能为：只有豹哥权限时以下路由跳转至申请上门页）
  checkRoleRoute: ['/manage-order', '/manage-stock', '/manage-data'],
  // aos app下载地址
  aosAppDownUrl: 'https://s1.huishoubao.com/iosjc/xyxz/MiniStation.apk',
  // ios app应用市场地址
  iosAppDownUrl: 'https://apps.apple.com/app/id1543828349',
  // 禁止下拉加载路由
  closePullRouter: [
    '/quotation-detail',
    '/quoted-price-search',
    '/quoted-price',
    '/apply-visitor',
    '/share-down',
    '/report',
    '/device-detail'
  ],
  // 一级页路由（不带路由最前的/）
  tabPage: ['manage-order', 'manage-stock', 'manage-data', 'to-apply-visitor'],
  isWeiXin: isWeiXin(),
  shareList: [
    {
      text: '微信好友',
      icon: require('../assets/imgs/report/share_icon_wechat@2x.png')
    },
    {
      text: '朋友圈',
      icon: require('../assets/imgs/report/share_icon_friend@2x.png')
    },
    {
      text: '复制链接',
      icon: require('../assets/imgs/report/share_icon_friend_copy@2x.png')
    }
  ]
};
export default config;
